import { ToastContainer, Slide } from "react-toastify";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Breadcrumbs from "../../../../components/Breadcrumbs/Breadcrumbs";
import Footer from "../../../../components/Footer/Footer";
import { useCartPage } from "../hooks/useCartPage";
import CartItem from "../components/CartItem";
import CartSummary from "../components/CartSummary";
import CartEmpty from "../components/CartEmpty";
import "../styles/CartPage.css";

const CartPage = () => {
  const { items, mrpTotal, discountTotal, total, loading, token, breadcrumbPaths } = useCartPage();

  if (!token) {
    return (
      <p style={{ padding: "2rem", textAlign: "center" }}>
        Please login to view your cart.
      </p>
    );
  }

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        limit={1}
        hideProgressBar
        transition={Slide}
        newestOnTop
        style={{ zIndex: 9999999 }}
      />

      <Breadcrumbs paths={breadcrumbPaths} />

      <div className="root-title-chk">
        <span className="title_chk">
          My Cart
          <span className="wishlist-header-count-cart">
            ({loading ? <Skeleton width={20} /> : items.length})
          </span>
        </span>
      </div>

      <div className="cart_mlb">
        <span className="txt_mlb_my">
          My Cart
          <span className="wishlist-header-count-cart" style={{ fontSize: "12px" }}>
            ({loading ? <Skeleton width={20} /> : items.length})
          </span>
        </span>
      </div>

      <div className="cart-container">
        <div className="cart-left">

          {/* Skeleton Loader */}
          {loading &&
            Array(3)
              .fill()
              .map((_, i) => (
                <div key={i} style={{ display: "flex", gap: "15px", marginBottom: "20px" }}>
                  <Skeleton height={90} width={90} />
                  <div style={{ flex: 1 }}>
                    <Skeleton height={20} width="70%" />
                    <Skeleton height={15} width="40%" style={{ marginTop: 10 }} />
                    <Skeleton height={15} width="30%" style={{ marginTop: 10 }} />
                  </div>
                </div>
              ))}

          {!loading && items.length === 0 && <CartEmpty />}

          {!loading &&
            items.length > 0 &&
            items.map((item) => <CartItem key={item.id} item={item} />)}

        </div>

        {!loading && items.length > 0 && (
          <CartSummary mrpTotal={mrpTotal} discountTotal={discountTotal} total={total} items={items} />
        )}
      </div>

      <Footer />
    </>
  );
};

export default CartPage;